
import React from 'react'

import './ContentBody.scss'
import { Col, Row } from 'react-bootstrap'

interface Props {
  noScroll?: boolean
  children: React.ReactNode
}

const MainContentBody = ({ noScroll, children }: Props) => {

  return (
    <div className={`content-body ul-widget__body scroller ${noScroll ? 'no-scroll' : ''}`}>
      <Row style={{ margin: 0, height: 'calc(100% - 8px)', width: '100%' }}>
        <Col className='' style={{ height: '100%' }}>
          {children}
        </Col>
      </Row>
    </div>
  )
}

export default MainContentBody
